import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess1230053Status: 'idle',
    startProcess1230053Error: undefined as any,
    loadUserParamsProcess1230053Status: 'idle',
    loadUserParamsProcess1230053Error: undefined as any,

    process1230053List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess1230053 = createAsyncThunk('process1230053Slice/startProcess1230053', async ({ process1230053 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess1230053/`,
        prepareData(process1230053),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess1230053Status } = getState().process1230053Slice
        return startProcess1230053Status !== 'pending'
    }
})

export const loadUserParamsProcess1230053 = createAsyncThunk('process1230053Slice/loadUserParamsProcess1230053', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess1230053/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess1230053Status } = getState().process1230053Slice
        return loadUserParamsProcess1230053Status !== 'pending'
    }
})

const Process1230053Slice = createSlice({
    name: 'process1230053Slice',
    initialState,
    reducers: {
        resetstartProcess1230053: (state) => {
            state.job = undefined
            state.startProcess1230053Error = undefined
        },
        resetstartProcess1230053Error: (state) => {
            state.startProcess1230053Error = undefined
        },
        resetloadUserParamsProcess1230053: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess1230053Error = undefined
        },
        resetloadUserParamsProcess1230053Error: (state) => {
            state.loadUserParamsProcess1230053Error = undefined
        },
        removeFromProcess1230053ListById: (state, action) => {
            state.process1230053List = state.process1230053List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess1230053ListByIds: (state, action) => {
            state.process1230053List = state.process1230053List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process1230053List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess1230053Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process1230053List = []
            state.startProcess1230053Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess1230053.pending, (state) => {
            state.startProcess1230053Status = 'pending'
            state.startProcess1230053Error = undefined
        })
        builder.addCase(startProcess1230053.fulfilled, (state, action) => {
            state.startProcess1230053Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess1230053.rejected, (state, action) => {
            state.startProcess1230053Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess1230053Error = action.error.message
            } else {
                state.startProcess1230053Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess1230053.pending, (state) => {
            state.loadUserParamsProcess1230053Status = 'pending'
            state.loadUserParamsProcess1230053Error = undefined
        })
        builder.addCase(loadUserParamsProcess1230053.fulfilled, (state, action) => {
            state.loadUserParamsProcess1230053Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess1230053.rejected, (state, action) => {
            state.loadUserParamsProcess1230053Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess1230053Error = action.error.message
            } else {
                state.loadUserParamsProcess1230053Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess1230053,
    resetstartProcess1230053Error,
    resetloadUserParamsProcess1230053,
    resetloadUserParamsProcess1230053Error,
    removeFromProcess1230053ListById,
    removeFromProcess1230053ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process1230053Slice.actions
export default Process1230053Slice.reducer
